import React from "react";
import { Outlet } from "react-router-dom";
const PropertyStatusRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default PropertyStatusRoot;
